module.exports = __webpack_public_path__ + "assets/7f5d1d8ad140a144e07289ded8fc54c1.png";